package navigation.home.service.addeditservice

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.gpt.domain.OpenAIClient
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.authentication.domain.repository.AuthRepository
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.file.domain.repository.FileRepository
import com.essntl.features.profile.domain.repository.ProfileRepository
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import com.essntl.features.service.domain.repository.ServiceRepository
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.features.service.ui.addeditservice.AddEditServiceValidation
import com.essntl.features.service.ui.addeditservice.AddEditServiceViewModel
import com.essntl.features.supplier.domain.repository.SupplierRepository
import com.essntl.features.tag.domain.repository.TagRepository
import com.essntl.toastmanager.ToastManager

class AddEditServiceScreenModel(
    serviceRepository: ServiceRepository,
    categoryRepository: CategoryRepository,
    supplierRepository: SupplierRepository,
    tagRepository: TagRepository,
    fileRepository: FileRepository,
    areaRepository: AreaRepository,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    toastManager: ToastManager,
    openAIClient: OpenAIClient,
    loadingManager: LoadingManager,
) : StateScreenModel<AddEditServiceState>(AddEditServiceState()) {
    val validation = AddEditServiceValidation()

    val vm =
        AddEditServiceViewModel(
            serviceRepository = serviceRepository,
            categoryRepository = categoryRepository,
            tagRepository = tagRepository,
            fileRepository = fileRepository,
            areaRepository = areaRepository,
            supplierRepository = supplierRepository,
            getCurrentUserUseCase = getCurrentUserUseCase,
            toastManager = toastManager,
            openAIClient = openAIClient,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager
        )

    fun onEvent(event: AddEditServiceEvent) {
        vm.onEvent(event)
    }
}
